import { getSiteSuccessType } from '../../../../APIDocs/apiTypes';
import { Card } from '../../components/Card';
import { Label } from '../../components/Label';
import { Title } from '@portal_components/components/Title';
import { Typography } from '../../components/Typography';
import { SiteDetailsLoading } from '../loadingElements/SiteDetailsLoading';
import { SiteAddress as SiteAddressComponent } from '../SiteAddress';

export interface props {
  dataErrorOccurred: boolean;
  data?: getSiteSuccessType;
  error: { msg?: string | undefined } | null;
  className?: string;
  loading: boolean;
}

export const SiteDetail = ({ dataErrorOccurred, data, error, className, loading }: props) => {
  const shouldRender = data?.SiteAddress != undefined;

  return (
    <div className="bg-white shadow rounded py-4">
      {loading ? (
        <SiteDetailsLoading className={''} />
      ) : error ? (
        <Typography content="Unable to load site details." />
      ) : (
        <div className={className ? className : ''}>
          <Title className="mb-4" text="Site Details:" />
          {error && error?.['msg'] == 'Site not found' ? (
            <Typography content="No data has been retrieved for the MPAN" />
          ) : dataErrorOccurred == true ? (
            <Typography content="Sorry, an error appears to exist with this data please contact support for assistance" />
          ) : data == undefined && error && error?.['msg'] == 'The server was unable to respond' ? (
            <Typography content="Sorry, an error has occurred with the server, please contact support for assistance" />
          ) : shouldRender ? (
            <Card className="p-5 pt-3" render={shouldRender} identifier="siteDetail">
              {data?.SiteAddress != undefined ? <SiteAddressComponent siteAddress={data?.SiteAddress} /> : <span></span>}
              {data?.SiteTypeDescription == undefined ? <div></div> : <Label title="Site Type" text={data.SiteTypeDescription}></Label>}
            </Card>
          ) : (
            <Typography content="No Site details available for this site" />
          )}
        </div>
      )}
    </div>
  );
};
